<template>
  <v-container id="categorias" tag="section">
    <base-v-component heading="Categorias del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-btn
          v-if="!ordenando"
          color="success"
          dark
          class="mb-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="isAdmin"
          :loading="loadingTraducir"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-4"
          @click="traducirLoQueSeVe()"
          >Traducir lo que se ve
          <v-icon class="ml-1" small>mdi-google-translate</v-icon></v-btn
        >
        <v-btn
          v-if="ordenando"
          color="success"
          dark
          class="mb-2"
          @click="ordenando = false"
          >Volver Listado</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-select
                  :items="idiomas"
                  v-model="langSeleccionado"
                  label="Selección idioma"
                  outline
                ></v-select>
                <template v-for="lang in idiomas">
                  <v-layout
                    wrap
                    :key="lang.value"
                    v-if="lang.value == langSeleccionado"
                  >
                    <v-flex xs12 sm12>
                      <h4>IDIOMA {{ lang.text }}</h4>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="nombreShow"
                        label="Nombre"
                        :error-messages="nombreErrors"
                        @input="$v.nombreValidar.$touch()"
                        @blur="$v.nombreValidar.$touch()"
                        ref="nombreReferencia"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-text-field
                        v-model="descripcionShow"
                        label="Descripcion"
                        :error-messages="descripcionErrors"
                        @input="$v.descripcionValidar.$touch()"
                        @blur="$v.descripcionValidar.$touch()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </template>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="categorias"
        sort-by="orden"
        :loading="loading"
        disable-pagination
        v-if="!ordenando"
      >
        <template v-slot:item.nombre="{ item }">{{
          mostrarIdioma(item.nombre)
        }}</template>
        <template v-slot:item.descripcion="{ item }">{{
          mostrarIdioma(item.descripcion)
        }}</template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small @click="editItemDialog(item)"
                    >mdi-pencil</v-icon
                  >
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-btn class="px-2 ml-1" color="red" min-width="0" small>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
      <v-row v-else align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenC">
              <div v-for="element in categoriasOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{
                    mostrarIdioma(element.nombre)
                  }}</v-list-item-content>
                  <v-list-item-action>{{ element.orden }}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { required, minLength } from 'vuelidate/lib/validators';
  import { mapState, mapGetters } from 'vuex';
  import { mostrarIdioma } from '@/utils/utils.js';
  import draggable from 'vuedraggable';
  export default {
    mixins: [validationMixin],
    components: {
      draggable,
    },
    validations: {
      nombreValidar: { required },
      descripcionValidar: { minLength: minLength(4) },
    },
    data() {
      return {
        loadingTraducir: false,
        orden: 0,
        ordenando: false,
        id: null,
        nombreIdiomas: null,
        nombreValidar: '',
        descripcionIdiomas: null,
        descripcionValidar: '',
        loading: false,
        loadingForm: false,
        dialog: false,
        headers: [
          {
            sortable: false,
            text: 'Nombre',
            value: 'nombre',
          },
          {
            sortable: false,
            text: 'Descripción',
            value: 'descripcion',
          },
          {
            sortable: false,
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
      };
    },
    computed: {
      ordenC: {
        get() {
          return this.categoriasOrden;
        },
        set(v) {
          var res = [];
          let _vm = this;
          v.forEach((e, i) => {
            let aux = {
              orden: i,
              id: e.id,
            };
            res.push(aux);
          });
          return this.$store
            .dispatch('categorias/ordenarCategorias', res)
            .then(() => {
              _vm.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Categorias ordenadas',
              });
              _vm.getCategorias();
            })
            .catch((e) => {
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al ordenar categorías',
              });
              console.log(e);
            });
        },
      },
      nombreErrors() {
        const errors = [];
        if (!this.$v.nombreValidar.$dirty) return errors;
        !this.$v.nombreValidar.required &&
          errors.push('Nombre idioma por defecto obligatorio.');
        return errors;
      },
      descripcionErrors() {
        const errors = [];
        if (!this.$v.descripcionValidar.$dirty) return errors;
        !this.$v.descripcionValidar.minLength &&
          errors.push('Descripción idioma por defecto demasiado corto.');
        return errors;
      },
      ...mapGetters({
        negocio: 'app/negocioGestObj',
        categoriasOrden: 'categorias/getCategoriasOrder',
        isAdmin: 'auth/isAdmin',
      }),
      ...mapState({
        categorias: (state) => state.categorias.categoriasArray,
        idiomas: 'idiomas',
        langDefecto: 'langDefecto',
      }),
      langSeleccionado: {
        get() {
          return this.$store.state.langSeleccionado;
        },
        set(v) {
          this.$store.commit('setLangSeleccionado', v);
        },
      },
      subtitulo() {
        return 'Listado de categorías de ' + this.negocio.nombre;
      },
      formTitle() {
        return this.isEdit ? 'Editar Categoria' : 'Nueva Categoria';
      },
      accion() {
        return this.id ? 'edit' : 'add';
      },
      isAdd() {
        return this.accion == 'add';
      },
      isEdit() {
        return this.accion == 'edit';
      },
      nombreShow: {
        get() {
          let _vm = this;
          var found = this.nombreIdiomas.find(
            (e) => e.lang == _vm.langSeleccionado
          );
          return found ? found.text : '';
        },
        set(v) {
          let _vm = this;
          var index = this.nombreIdiomas.findIndex(
            (e) => e.lang == _vm.langSeleccionado
          );
          var defecto = this.nombreIdiomas.find(
            (e) => e.lang == _vm.langDefecto
          );
          this.nombreValidar = defecto.text;
          this.nombreIdiomas[index].text = v;
        },
      },
      descripcionShow: {
        get() {
          let _vm = this;
          var found = this.descripcionIdiomas.find(
            (e) => e.lang == _vm.langSeleccionado
          );
          return found ? found.text : '';
        },
        set(v) {
          let _vm = this;
          var index = this.descripcionIdiomas.findIndex(
            (e) => e.lang == _vm.langSeleccionado
          );
          var defecto = this.descripcionIdiomas.find(
            (e) => e.lang == _vm.langDefecto
          );
          this.descripcionValidar = defecto.text;
          this.descripcionIdiomas[index].text = v;
        },
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      traducirLoQueSeVe() {
        console.log(this.categorias);

        this.loadingTraducir = true;
        let traducir = this.categorias
          .map((prd) => {
            return [
              {
                id: prd.id,
                key: 'nombre',
                texto: prd.nombre,
              },
              {
                id: prd.id,
                key: 'descripcion',
                texto: prd.descripcion,
              },
            ];
          })
          .flat();
        this.$store
          .dispatch('traducir', traducir)
          .then((r) => {
            console.log(_.groupBy(r, 'id'));
            let agrupados = _.groupBy(r, 'id');
            var promesas = [];
            for (let prop in agrupados) {
              let propDinamicas = {};
              agrupados[prop].forEach((p) => {
                propDinamicas[p.key] = p.texto;
              });
              console.log(agrupados);
              let objGuardar = {
                id: prop,
                ...propDinamicas,
              };
              console.log(objGuardar);
              promesas.push(
                this.$store
                  .dispatch('categorias/addCategoria', {
                    ...objGuardar,
                  })
                  .catch((e) => console.log(e))
              );
            }
            return Promise.all(promesas);
          })
          .finally(() => {
            this.getCategorias();
            this.loadingTraducir = false;
          });
      },
      mostrarIdioma(s) {
        return mostrarIdioma(s);
      },
      reload() {
        this.getCategorias();
      },
      showDialog() {
        this.dialog = true;
        //this.$nextTick(this.$refs.nombreReferencia.focus())
      },
      editItemDialog(item) {
        this.nombreIdiomas = JSON.parse(JSON.stringify(item.nombre));
        this.descripcionIdiomas = JSON.parse(JSON.stringify(item.descripcion));
        this.showDialog();
        this.id = item.id;
        this.orden = item.orden ? item.orden : 0;
      },
      deleteItem(item) {
        let r = confirm(
          '¿Quieres eliminar la categoría? (no se puede deshacer)'
        );
        if (r) {
          this.loading = true;
          let _vm = this;
          this.$store
            .dispatch('categorias/deleteCategoria', item)
            .then((res) => {
              _vm.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Categoría eliminada',
              });
              _vm.getCategorias();
            })
            .catch((error) => {
              _vm.$store.commit('snackbar/setMensajeDanger', {
                msj: 'Error al eliminar',
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      getCategorias() {
        this.loading = true;
        let _vm = this;
        return this.$store.dispatch('categorias/getCategorias').finally(() => {
          _vm.loading = false;
        });
      },
      close() {
        this.dialog = false;
        this.$v.$reset();
        let _vm = this;
        setTimeout(() => {
          _vm.reiniciarDatos();
        }, 300);
      },
      reiniciarDatos() {
        let a_nombre = [];
        let a_descripcion = [];
        for (var lang of this.idiomas) {
          let aux_1 = { lang: lang.value, text: '' };
          let aux_2 = { lang: lang.value, text: '' };
          a_nombre.push(aux_1);
          a_descripcion.push(aux_2);
        }
        this.id = null;
        this.nombreIdiomas = a_nombre;
        this.descripcionIdiomas = a_descripcion;
        this.$store.commit('setLangSeleccionadoDefecto');
      },
      addCategoria() {
        let categoria = {
          descripcion: this.descripcionIdiomas,
          nombre: this.nombreIdiomas,
          negocio: this.negocio.id,
          id: this.id ? this.id : null,
          orden: this.orden ? this.orden : 0,
        };
        return this.$store.dispatch('categorias/addCategoria', categoria);
      },
      save() {
        let _vm = this;
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.loadingForm = true;
          if (this.isAdd || this.isEdit) {
            this.addCategoria()
              .then((res) => {
                _vm.$store.commit('snackbar/setMensajeSuccess', {
                  msj: 'Categoría grabada con éxito',
                });
                _vm.getCategorias();
                _vm.dialog = false;
              })
              .catch((error) => {
                console.log(error);
                _vm.$store.commit('snackbar/setMensajeDanger', {
                  msj: 'Error al guardar la categoria',
                });
              })
              .finally(() => {
                _vm.loadingForm = false;
              });
          }
        }
      },
    },
    beforeMount() {
      let a_nombre = [];
      let a_descripcion = [];
      for (var lang of this.idiomas) {
        let aux_1 = { lang: lang.value, text: '' };
        let aux_2 = { lang: lang.value, text: '' };
        a_nombre.push(aux_1);
        a_descripcion.push(aux_2);
      }
      this.nombreIdiomas = a_nombre;
      this.descripcionIdiomas = a_descripcion;
    },
    mounted() {
      let _vm = this;
      this.getCategorias();
    },
  };
</script>

<style></style>
